import React from "react";
import "./HeroSection.css";
import HeroData from "./HeroData";

const HeroSection = () => {
  return (
    <div className="h-wrapper">
      <div className="container mt-24">
        <img src="hero/hero-arrow.png" alt="" className="h-arrow" />
        <div className="h-container">
          {/* left Side */}
          <div className="h-left">
            <div className="image-row">
              {HeroData.slice(0, 3).map((person, i) => (
                <div className="person-pill" key={i}>
                  <div
                    className="person-pill-bg"
                    style={{ backgroundColor: person.bg }}
                  >
                    <img src={person.src} alt={person.src} />
                  </div>
                </div>
              ))}
            </div>
            <div className="image-row">
              {HeroData.slice(3, 6).map((person, i) => (
                <div className="person-pill" key={i}>
                  <div
                    className="person-pill-bg"
                    style={{ backgroundColor: person.bg }}
                  >
                    <img src={person.src} alt={person.src} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* right Side */}
          <div className="h-right">
            <div className="h-title">
              <span className="text-[#54F3A6]">Redefine How</span>
              <span className="text-[#54F3A6]">You Grow your</span>
              <span className="text-white">Digital Business</span>
            </div>

            <div className="h-description text-white font-sans">
              Revenue based funding and execution support designed <br /> for
              early stage founders
            </div>
            {/* Email Input and Subscribe Button */}
            <div className="email-box">
              <input
                type="email"
                placeholder="Enter your email"
                className="email-input"
              />
              <button className="subscribe-button">Subscribe</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
